import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_c_15_tabbed_content() {
  const sections = document.querySelectorAll('section.c-15-tabbed-content');

  sections.forEach((section) => {
    const viewports = section.querySelectorAll('.swiper');
    if (!viewports.length) return;

    viewports.forEach((viewport) => {
      if (viewport.dataset.swiperInit === '1') return; // prevent double init

      const ctx = viewport.closest('.slider') || viewport.parentElement || section;

      // Build Swiper structure
      let wrapper = viewport.querySelector('.swiper-wrapper');
      let slides = Array.from(viewport.querySelectorAll('.slide'));
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        slides.forEach((el) => el.classList.add('swiper-slide'));
        viewport.replaceChildren(wrapper);
        slides.forEach((el) => wrapper.appendChild(el));
      } else {
        slides.forEach((el) => el.classList.add('swiper-slide'));
      }

      // Count slides and scope controls
      const slidesCount = wrapper.children.length;
      const hasMultiple = slidesCount > 1;

      const prevButtons = ctx.querySelectorAll('.swiper-btn.prev');
      const nextButtons = ctx.querySelectorAll('.swiper-btn.next');

      // Hide buttons if only 1 slide
      if (!hasMultiple) {
        prevButtons.forEach((b) => b.classList.add('d-none'));
        nextButtons.forEach((b) => b.classList.add('d-none'));
      }

      const swiper = new Swiper(viewport, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 600,
        allowTouchMove: hasMultiple,
        loop: false,
        navigation: {
          enabled: hasMultiple,
          prevEl: hasMultiple ? prevButtons[0] || null : null,
          nextEl: hasMultiple ? nextButtons[0] || null : null,
        },
      });

      // Update all nav buttons (extra controls) based on swiper state
      const updateNavState = () => {
        const atStart = swiper.isBeginning;
        const atEnd = swiper.isEnd;
        prevButtons.forEach(b => {
          b.disabled = !!atStart;
          b.classList.toggle('disabled', !!atStart);
        });
        nextButtons.forEach(b => {
          b.disabled = !!atEnd;
          b.classList.toggle('disabled', !!atEnd);
        });
      };
      swiper.on('slideChange', updateNavState);
      // ensure initial state is correct
      updateNavState();

      // If multiple controls exist in the same context, wire extras
      if (hasMultiple) {
        prevButtons.forEach((btn, i) => {
          if (i > 0) btn.addEventListener('click', (e) => { e.preventDefault(); swiper.slidePrev(); });
        });
        nextButtons.forEach((btn, i) => {
          if (i > 0) btn.addEventListener('click', (e) => { e.preventDefault(); swiper.slideNext(); });
        });
      } else if (swiper.navigation?.disable) {
        swiper.navigation.disable();
      }
      // ensure any programmatic slide (external callers) also update nav state
      // (keeps parity when other code calls slideTo/slideNext/slidePrev)
      swiper.on('reachBeginning reachEnd fromEdge', updateNavState);

      viewport.dataset.swiperInit = '1';
    });


    document.querySelectorAll('.carousel-titles').forEach(titleList => {
        const carouselId = titleList.dataset.carouselId;
        const swiperEl = document.getElementById(carouselId);
        if (!swiperEl) return;

        // Use the existing Swiper instance created above
        const swiper = swiperEl.swiper;
        if (!swiper) return;

        const updateTitles = () => {
          const activeIndex = swiper.realIndex;
          titleList.querySelectorAll('li').forEach((li, i) => {
            li.classList.toggle('active', i === activeIndex);
          });
        };
        swiper.on('slideChange', () => {
          updateTitles();
          // update all nav buttons scoped to this swiper
          const ctx = swiperEl.closest('.slider') || swiperEl.parentElement || document;
          const prevButtons = ctx.querySelectorAll('.swiper-btn.prev');
          const nextButtons = ctx.querySelectorAll('.swiper-btn.next');
          const atStart = swiper.isBeginning;
          const atEnd = swiper.isEnd;
          prevButtons.forEach(b => { b.disabled = !!atStart; b.classList.toggle('disabled', !!atStart); });
          nextButtons.forEach(b => { b.disabled = !!atEnd; b.classList.toggle('disabled', !!atEnd); });
        });

        // Click titles to slide
        titleList.querySelectorAll('li').forEach((li, i) => {
            li.addEventListener('click', (e) => {
                e.preventDefault();
                const index = parseInt(li.dataset.index || i, 10);
                swiper.slideTo(index);
            });
        });

        // initialise titles state
        updateTitles();
    });

  });
}

export { dm_c_15_tabbed_content };